import axios from 'axios';
import {
  CreateSnapshotMarkerDeltaDto,
  Snapshot,
  SnapshotMarkerDelta,
  TraceHistory,
  TraceHistorySample,
  UpdateSnapshotDto,
} from 'types';
import { convertSnapshot, convertMarkerDelta } from './dtoConverters';

export async function getTraceHistory(
  id: number,
  fromTime: string,
  toTime: string
): Promise<TraceHistory[]> {
  let url = `/api/snapshots/${id}/history/${fromTime}/${toTime}`;

  try {
    const { data } = await axios.get(url);
    return data as TraceHistory[];
  } catch (err) {
    throw err;
  }
}

export async function getTraceHistoryCount(
  id: number,
  fromTime: string,
  toTime: string
): Promise<TraceHistory[]> {
  let url = `/api/snapshots/${id}/history/count/${fromTime}/${toTime}`;

  try {
    const { data } = await axios.get(url);
    return data as TraceHistory[];
  } catch (err) {
    throw err;
  }
}

export async function getTraceHistoryByPage(
  id: number,
  fromTime: string,
  toTime: string,
  page?: number | undefined | null
): Promise<TraceHistory[]> {
  if (page === undefined || page === null) page = 0;
  let url = `/api/snapshots/${id}/history-page/${fromTime}/${toTime}?page=${page}`;

  try {
    const { data } = await axios.get(url);
    return data as TraceHistory[];
  } catch (err) {
    throw err;
  }
}

export async function getTraceHistoryExport(
  id: number,
  fromTime: string,
  toTime: string
): Promise<Blob> {
  const url = `/api/snapshots/${id}/history-export/${fromTime}/${toTime}`;
  try {
    const { data } = await axios.get(url, { responseType: 'blob' });
    return data as Blob;
  } catch (err) {
    throw err;
  }
}

export async function getTraceHistorySample(
  id: number,
  time: string
): Promise<TraceHistorySample> {
  const url = `/api/snapshots/${id}/history/sample/${time}`;
  try {
    const { data } = await axios.get(url);
    return data as TraceHistorySample;
  } catch (err) {
    throw err;
  }
}

export async function getTraceHistorySamples(
  id: number,
  fromTime: string,
  toTime: string
): Promise<TraceHistorySample[]> {
  const url = `/api/snapshots/${id}/history/samples/${fromTime}/${toTime}`;
  try {
    const { data } = await axios.get(url);
    return data as TraceHistorySample[];
  } catch (err) {
    throw err;
  }
}

export async function insertSnapshotMarkerDelta(
  snapshotId: number,
  markerDelta: CreateSnapshotMarkerDeltaDto
): Promise<SnapshotMarkerDelta> {
  const url = `/api/snapshots/${snapshotId}/marker-deltas`;
  try {
    const { data } = await axios.post(url, convertMarkerDelta(markerDelta));
    return data as SnapshotMarkerDelta;
  } catch (err) {
    throw err;
  }
}

export async function updateSnapshot(
  id: number,
  snapshot: UpdateSnapshotDto
): Promise<Snapshot> {
  const url = `/api/snapshots/${id}`;

  try {
    const { data } = await axios.put(url, convertSnapshot(snapshot));
    return data as Snapshot;
  } catch (err) {
    throw err;
  }
}

export async function clearSnapshotMarkerDeltas(
  snapshotId: number
): Promise<void> {
  const url = `/api/snapshots/${snapshotId}/marker-delta`;
  try {
    await axios.delete(url);
  } catch (err) {
    throw err;
  }
}
